<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader/>

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">

      <LeftMenu/>

      <div class="m-grid__item m-grid__item--fluid m-wrapper">

        <div class="m-content">


          <div class="row flex-md-column-reverse flex-sm-column-reverse flex-xxl-row flex-column-reverse">

            <div class="col-xxl- col-xl-12 col-lg-12 col-md-12">
            </div>


            <div class="col-xxl- col-xl-12">

              <!--Begin::Table-->

              <div class="m-portlet m-portlet--head-sm m-portlet--rounded fullable-portlet"
                   :m-portlet="'true'" id="invoiceHistoryPortlet">
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                          <i class="flaticon-piggy-bank m--font-brand m--icon-font-size-lg2 mt-n1"></i>
                      </span>
                      <h3 class="m-portlet__head-text">
                        {{ $t('Invoicing.transaction')}} <small> {{ $t('Invoicing.transactionDesc')}}</small>
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">
                      <li class="m-portlet__nav-item">
                        <a href="javascript:"
                           :m-portlet-tool="'fullscreen'" class="m-portlet__nav-link m-portlet__nav-link--icon"><i
                          class="la la-expand"></i></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="m-portlet__body">

                  <div class="table_sticky-header">
                    <table class="table m-table m-table--head-no-border table table-striped" id="invoiceTable">

                      <thead>
                        <tr class="">
                          <th style="width:auto;" class="text-left"># {{ $t('Invoicing.table.InvoiceID')}}</th>
                          <th style="width:auto;" class="text-left">{{ $t('Invoicing.table.date')}}</th>
                          <th style="width:auto;" class="text-left">{{ $t('Invoicing.table.status')}}</th>
                          <th style="width:auto;" class="text-xs-left text-md-left text-right">{{ $t('Invoicing.table.Total')}}</th>

                          <th style="width:auto;" class="text-xs-left text-md-left text-right">{{ $t('Invoicing.table.Actions')}}</th>
                        </tr>
                      </thead>


                      <tbody>

                      <!-- Begin: transactions tr's-->
                      <template >
                        <tr v-for="(transaction, key) in transactions" :key="key">
                          <template>
                          <td class="align-middle" :data-thead-name="'#'+ $t('Invoicing.table.InvoiceID')">{{transaction.Number}}</td>
                          <td class="align-middle" :data-thead-name="$t('Invoicing.table.date')">{{formatDate(transaction.Date)}}</td>

                          <td class="text-left align-middle" :data-thead-name="$t('Invoicing.table.status')">
                            <span>
                              <i class="m--font-success la la-check" v-if="transaction.Status == 'PAID'"></i>
                              <i class="m--font-danger la la-close" v-else></i>
                            </span>
                          </td>

                          <td class="align-middle text-xs-left text-md-left text-lg-right" :data-thead-name="$t('Invoicing.table.Total')">{{transaction.Total}} &euro;</td>

                          <td class="align-middle text-xs-left text-md-left text-right actionBtnTd">
                            <div class="m-separator dark m-separator--dashed my-4 d-block d-lg-none d-xl-none"></div>
                            <a href="javascript:" :id="'actionBtn'+transaction.Id"
                               class="m-portlet__nav-link m-dropdown__toggle btn m-btn m-btn--link" data-toggle="dropdown"
                               aria-haspopup="true" aria-expanded="true">
                              <i class="la la-ellipsis-h"></i>
                            </a>

                            <div class="dropdown-menu m-dropdown__wrapper" :aria-labelledby="'actionBtn'+transaction.Id">
                              <div class="px-1">
                                <ul class="m-nav">
                                  <li class="m-nav__item">
                                    <a href="javascript:" v-on:click="showAsPdf(transaction.Number)"
                                       class="btn btn-outline-brand m-btn btn-block m-btn--wide btn-sm">
                                      <small>PDF </small><i class="la la-file-pdf-o"></i>
                                    </a>

                                  </li>
                                  <li class="m-nav__item mt-1">
                                    <a href="javascript:" v-on:click="downloadAsPdf(transaction.Number)"
                                       class="btn btn-outline-brand m-btn btn-block m-btn--wide btn-sm">
                                      <small>{{ $t('Invoicing.table.download')}} </small><i class="la la-download"></i>
                                    </a>

                                  </li>
                                </ul>
                              </div>
                            </div>

                          </td>
                          </template>

                        </tr>
                      </template>
                      <template v-if="transactions.length === 0">
                        <tr>
                          <td colspan="11" class="text-center m--regular-font-size-lg3 py-3">
                            {{this.$t('Property.table.NoRecordsFound')}}
                          </td>
                        </tr>
                      </template>
                      <!-- Begin: transactions tr's-->


                      </tbody>
                    </table>
                  </div>

                </div>


                <div class="modal fade" id="modalPreviewPDF" tabindex="-1" role="dialog" aria-labelledby="modalPreviewPDF"
                     aria-hidden="true" data-backdrop="static" data-keyboard="false">
                  <div class="modal-dialog modal-xl m-portlet--fullscreen" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="row">
                          <div class="col-xl-12" id="previewPDF">
                            <div id="pdf" style="width:100%; height: 75vh;"></div>
                            <div id="embedPDF"></div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                      </div>
                    </div>
                  </div>
                </div>


              </div>

              <Pagination
                :total-pages="pagination.pages"
                :total="pagination.total"
                :per-page="resultsPerPage"
                :loading="false"
                :current-page="pagination.currentPage"
                @pagechanged="onPageChange">

              </Pagination>

              <!--end::Table-->
            </div>

          </div>


        </div>

      </div>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter/>
    <!-- END: Footer -->
  </div>
</template>

<script>

  import PDFObject from 'pdfobject';

  import functions from '@/plugins/functions'
  import {clientapi} from '@/interceptors/clientapi'

  import AppHeader from '@/components/dashboard/common/Header';
  import AppFooter from '@/components/dashboard/common/Footer';
  import LeftMenu from '@/components/dashboard/common/menus/LeftMenu';

  import Pagination from '@/components/dashboard/common/Pagination';
  import dayjs from 'dayjs'

  export default {
    components: {
      AppFooter,
      AppHeader,
      LeftMenu,
      Pagination
    },
    mounted() {
      this.getInvoiceHistory();
    },
    beforeRouteLeave (to, from, next) {
      $('#modalPreviewPDF').modal('hide')
      next()
    },
    beforeDestroy(){
      $('#modalPreviewPDF').modal('hide')
    },
    data() {
      return {
        resultsPerPage: 20,
        invoiceName: '',
        loading: false,
        transactions: [],
        total: 0,
        pagination: {
          pages: 0,
          total: 0,
          currentPage: 1,
          maxVisibleButtons: 3,
        },
      }
    },
    methods: {
      async showAsPdf(invoiceId) {
        let formattedInvoiceId = invoiceId.replace(' / ', '-')
        let invoiceResponse = await clientapi.get('/invoice/' + formattedInvoiceId)

        if (invoiceResponse.status != 200) {
          let errorCode = invoiceResponse.data.code
          swal({
            title: this.$t('error.AnErrorOccurred'),
            text: this.$t('error.server.'+errorCode),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
        }

        let modal = document.getElementById('modalPreviewPDF');
        let modalBody = document.getElementById('previewPDF');
        let obj = document.createElement('object')
        let modalTitle = document.getElementsByClassName('modal-title')[0]

        modalBody.appendChild(obj)
        modalTitle.innerText = formattedInvoiceId

        let options = {
          pdfOpenParams: {
            pagemode: "none",
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",

          },
          fallbackLink: this.$t('common.unsupportedInlinePDF', {url: "data:application/pdf;base64," + encodeURI(invoiceResponse.data)})
        };

        PDFObject.embed("data:application/pdf;base64," + invoiceResponse.data, "#pdf", options);
        $(modal).modal("show")
      },
      async downloadAsPdf(invoiceId) {
        let formattedInvoiceId = invoiceId.replace(' / ', '-')

        let invoiceResponse = await clientapi.get('/invoice/' + formattedInvoiceId)

        if (invoiceResponse.status != 200) {
          let errorCode = invoiceResponse.data.code
          swal({
            title: this.$t('error.AnErrorOccurred'),
            text: this.$t('error.server.'+errorCode),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
        }

        let modalBody = document.getElementById('previewPDF');
        let obj = document.createElement('object')
        let modalTitle = document.getElementsByClassName('modal-title')[0]

        modalBody.appendChild(obj)
        modalTitle.innerText = formattedInvoiceId

        // Insert a link that allows the user to download the PDF file
        let link = document.createElement("a");
        link.innerHTML = "Download PDF file";
        link.download = formattedInvoiceId + ".pdf";
        link.href = "data:application/pdf;base64," + encodeURI(invoiceResponse.data);
        document.body.appendChild(link);
        link.click();
        link.remove();
      },
      formatDate(date) {
        return dayjs(date).tz().format('DD/MM/YYYY')
      },
      async getInvoiceHistory() {
        mApp.block("body", {message: this.$t('common.LoadingDataPleaseWait')});
        let params = {
          FromDate: dayjs().subtract(18, 'month').add(1, 'day').tz().endOf('day').format(),
          ToDate: dayjs().tz().endOf('day').format(),
          Take: this.resultsPerPage,
          Skip: (this.pagination.currentPage - 1) * this.resultsPerPage
        }

        let countParams = JSON.parse(JSON.stringify(params))
        delete countParams.Take
        delete countParams.Skip

        let countCall = clientapi.get('/invoicehistory/count', {params: countParams})
        let invoicesCall = clientapi.get('/invoicehistory', {params})

        let [countResponse, invoicesResponse] = await Promise.all([countCall, invoicesCall]);

        if (countResponse.status !== 200 || invoicesResponse.status != 200) {
          let errorCode = countResponse.data.code ? countResponse.data.code : invoicesResponse.data.code
          swal({
            title: this.$t('error.AnErrorOccurred'),
            text: this.$t('error.server.'+errorCode),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          mApp.unblock("body");
          return
        }

        this.transactions = invoicesResponse.data
        this.pagination.pages = Math.ceil(countResponse.data.Count / this.resultsPerPage);
        this.pagination.total = countResponse.data.Count;
        mApp.unblock("body");
      },
      onPageChange(page) {
        this.pagination.currentPage = page;
        this.getInvoiceHistory();
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/dashboard/invoicing/Invoicing.vue